<template>
  <el-form
    style="margin-top: 16px"
    :model="entity"
    :rules="rules"
    ref="form"
    label-width="140px"
    v-if="entity"
  >
    <!-- <el-form-item
      v-if="relationshipEnabled"
      label="Type"
      prop="type"
    >
      <el-select
        placeholder="Please select one option"
        label="Type"
        prop="type"
        v-model="entity.type"
      >
        <el-option label="Full" value="full" />
        <el-option label="Embedded" value="embedded" />
      </el-select>

      <div
        class="leading-7 text-xs font-medium text-gray-500"
      >
        <div>
          - Full: ScaffoldHub will generate the full
          capabilities for the entity - including list,
          view, export, export and form pages.
        </div>
        <div>
          - Embedded: It means the entity is desigend to be
          embedded on a Full entity. An example is a Order
          Item. Order Item would be embedded on the Order
          and include Product and Quantity.
        </div>
      </div>
    </el-form-item> -->

    <el-form-item
      v-if="nameEnabled"
      label="Name"
      prop="name.singular"
    >
      <el-input
        v-model="entity.name.singular"
        v-on:input="onNameChange()"
      ></el-input>
    </el-form-item>

    <el-form-item
      v-if="namePluralEnabled"
      label="Name Plural"
      prop="name.plural"
    >
      <el-input v-model="entity.name.plural"></el-input>
    </el-form-item>

    <el-form-item
      v-if="labelEnabled"
      label="Label"
      prop="label.singular"
    >
      <el-input v-model="entity.label.singular"></el-input>
    </el-form-item>

    <el-form-item
      v-if="labelPluralEnabled"
      label="Label Plural"
      prop="label.plural"
    >
      <el-input v-model="entity.label.plural"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
import variableNamePattern from '../../util/variable-name-regex';
import NameLabelNormalizer from '../name-label-normalizer';

const buildRules = (store) => {
  const nameRequired =
    store.getters['builder/entityName/required'];
  const namePluralRequired =
    store.getters['builder/entityNamePlural/required'];
  const labelRequired =
    store.getters['builder/entityLabel/required'];
  const labelPluralRequired =
    store.getters['builder/entityLabelPlural/required'];
  // const relationshipEnabled =
  //   store.getters['builder/relationship/enabled'];

  const rules = {};

  // if (relationshipEnabled) {
  //   rules['type'] = [
  //     {
  //       required: true,
  //       message: 'Type is required',
  //       trigger: 'blur',
  //     },
  //   ];
  // }

  if (nameRequired) {
    rules['name.singular'] = [
      {
        required: true,
        message: 'Name is required',
        trigger: 'blur',
      },
      {
        pattern: /^[_a-zA-Z][_a-zA-Z0-9]*$/,
        message: 'Name is not a valid variable name',
        trigger: 'blur',
      },
      {
        pattern: variableNamePattern,
        message: 'Name is not a valid variable name',
        trigger: 'blur',
      },
    ];
  }

  if (namePluralRequired) {
    rules['name.plural'] = [
      {
        required: true,
        message: 'Name Plural is required',
        trigger: 'blur',
      },
      {
        pattern: /^[_a-zA-Z][_a-zA-Z0-9]*$/,
        message: 'Plural name is not a valid variable name',
        trigger: 'blur',
      },
      {
        pattern: variableNamePattern,
        message: 'Plural name is not a valid variable name',
        trigger: 'blur',
      },
    ];
  }

  if (labelRequired) {
    rules['label.singular'] = [
      {
        required: true,
        message: 'Label is required',
        trigger: 'blur',
      },
    ];
  }

  if (labelPluralRequired) {
    rules['label.plural'] = [
      {
        required: true,
        message: 'Label Plural is required',
        trigger: 'blur',
      },
    ];
  }

  return rules;
};

export default {
  name: 'app-entity-form-basic',

  data() {
    return {
      rules: buildRules(this.$store),
    };
  },

  mounted() {
    if (
      this.$refs.tooltip1 &&
      this.$refs.tooltip1.referenceElm
    ) {
      this.$refs.tooltip1.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    if (
      this.$refs.tooltip2 &&
      this.$refs.tooltip2.referenceElm
    ) {
      this.$refs.tooltip2.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    if (
      this.$refs.tooltip3 &&
      this.$refs.tooltip3.referenceElm
    ) {
      this.$refs.tooltip3.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    if (
      this.$refs.tooltip4 &&
      this.$refs.tooltip4.referenceElm
    ) {
      this.$refs.tooltip4.referenceElm.setAttribute(
        'tabindex',
        -1,
      );
    }
    this.$store.commit(
      'builder/entityCurrent/basicForm',
      this.$refs.form,
    );
  },

  computed: {
    ...mapGetters({
      entity: 'builder/entityCurrent/current',
      nameEnabled: 'builder/entityName/enabled',
      namePluralEnabled: 'builder/entityNamePlural/enabled',
      labelEnabled: 'builder/entityLabel/enabled',
      labelPluralEnabled:
        'builder/entityLabelPlural/enabled',
      relationshipEnabled: 'builder/relationship/enabled',
    }),
  },

  methods: {
    onNameChange() {
      const nameSingular = this.entity.name.singular;

      if (this.namePluralEnabled) {
        this.entity.name.plural = NameLabelNormalizer.createPlural(
          nameSingular,
        );
      }

      if (this.labelEnabled) {
        this.entity.label.singular = NameLabelNormalizer.createLabel(
          nameSingular,
        );
      }

      if (this.labelPluralEnabled) {
        this.entity.label.plural = NameLabelNormalizer.createLabelPlural(
          nameSingular,
        );
      }
    },
  },
};
</script>

<style></style>
